import {Box, capitalize, Checkbox, FormControl} from "@mui/material";
import {Field} from "formik";
import {TextField} from 'formik-mui';
import {useOnboardingHandling} from "../../hooks/onboarding/useOnboardingHandling";
import {onboardingStyles} from "../../styles/onboarding/onboarding.styles";
import BranchenSelect from "./BranchenSelect";
import TelefonnummerInput from "../TelefonnummerInput";
import Germany from "../data/Flags/Germany";
import ButtonShowOnboardingDataPrivacy from "./ButtonShowOnboardingDataPrivacy";
import OnboardingAufgabenSelect from "./OnboardingAufgabenSelect";

export default function FieldsContentOnboarding() {
    const {translation} = useOnboardingHandling()

    return (
        <Box id={'fields-content-onboarding-call-box'}
             display={"grid"}
             sx={onboardingStyles.fieldsContentOnboarding.box}
        >
            <Box sx={onboardingStyles.fieldsContentOnboarding.namesBox}>
                <Field
                    component={TextField}
                    label={capitalize(translation('onboarding-attributes-first-name'))}
                    name='vorname'
                    required
                />
                <Field
                    component={TextField}
                    label={capitalize(translation('onboarding-attributes-last-name'))}
                    name='nachname'
                    required
                />
            </Box>
            <Field
                component={TextField}
                label={capitalize(translation('onboarding-attributes-company'))}
                name='firma'
                required
            />
            <Field
                component={TextField}
                label={capitalize(translation('onboarding-attributes-company-website'))}
                name='webseite'
            />
            <Field
                component={BranchenSelect}
                name={"branche"}
                label={capitalize(translation('onboarding-attributes-company-industry'))}
                required
            />
            <Field
                component={TextField}
                label={capitalize(translation('onboarding-attributes-email'))}
                name='email'
                required
            />
            <Field
                component={OnboardingAufgabenSelect}
                name={"aufgabeId"}
                label={capitalize(translation('onboarding-attributes-use-case'))}
                required
            />
            <Field
                component={TelefonnummerInput}
                label={capitalize(translation('onboarding-attributes-phone'))}
                name='telefonnummer'
                required
                country={{
                    flag: <Germany/>,
                    prefix: "+49",
                    flagKey: "germany",
                }}
            />
            <Field name="telefonnummerBestaetigt">
                {({field, form}: any) => (
                    <FormControl required>
                        <Box display="flex" alignItems="center">
                            <Checkbox
                                {...field}
                                checked={field.value}
                                onChange={(event) =>
                                    form.setFieldValue(field.name, event.target.checked)
                                }
                            />
                            {capitalize(translation('confirmation-phone'))}
                        </Box>
                    </FormControl>
                )}
            </Field>
            <Field name="datenschutzBestaetigt">
                {({field, form}: any) => (
                    <FormControl required>
                        <Box display="flex" alignItems="center">
                            <Checkbox
                                {...field}
                                checked={field.value}
                                onChange={(event) =>
                                    form.setFieldValue(field.name, event.target.checked)
                                }
                            />
                            <Box>
                                {capitalize(translation("confirmation-data-privacy-before-link"))}
                                <ButtonShowOnboardingDataPrivacy/>
                                {capitalize(translation("confirmation-data-privacy-after-link"))}
                            </Box>
                        </Box>
                    </FormControl>
                )}
            </Field>
        </Box>
    );
}
